import React, { useState, useEffect, useRef }   from 'react';
import axios                                    from 'axios';
import { useLocation }                          from 'react-router-dom';
import ContactsList                             from '../SAT/ContactsList';
import MessageInput                             from '../SAT/MessageInput';
import MessagesList                             from '../SAT/MessagesList';
import { 
    Alert, 
    Box, 
    Container, 
    Divider, 
    Snackbar, 
    Typography 
}  from '@mui/material';
import ApiService from '../../components/service/ApiService';

const ChatPageCliente = () => {
    const location = useLocation();

    const user = JSON.parse(sessionStorage.getItem("user"));
    const token = user?.token;
    const idCliente = user?.id;

    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
    };

    const [contacts,                setContacts                 ] = useState([]);
    const [activeChat,              setActiveChat               ] = useState(null);
    const [chatHistory,             setChatHistory              ] = useState([]);
    const [newMessage,              setNewMessage               ] = useState('');
    const [loading,                 setLoading                  ] = useState(false);
    const [messageCount,            setMessageCount             ] = useState(0); 
    const [lastReceivedMessageId,   setLastReceivedMessageId    ] = useState(null);
    const [snackbarOpen,            setSnackbarOpen             ] = useState(false);    
    const chatEndRef = useRef(null);


    useEffect(() => {
        const fetchContacts = async () => {
            setLoading(true);
            try {
                // const response = await axios.get(`http://localhost:8080/messaggio/elenco?id=${idCliente}&tipo=1`, { headers });
                const response = await ApiService.request(
                    'elencoMessaggi', 
                    { id: idCliente, tipo: 1 }, 
                    {}, 
                    
                );
                if (response.data && Array.isArray(response.data.messaggi)) {
                    const groupedContacts = {};
                    response.data.messaggi.forEach((msg) => {
                        const { idReso } = msg;
                        if (!groupedContacts[idReso]) {
                            groupedContacts[idReso] = {
                                id:             msg?.id,
                                idReso:         idReso,
                                idDestinatario: msg?.testi[0]?.idDestinatario,

                                messaggi:       msg.testi.map((testo) => ({
                                    from: testo.idMittente,
                                    text: testo.descrizione,
                                    date: testo.data,
                                    id:   testo.id,
                                })),
                            };
                        }
                    });
    
                    const uniqueContacts = Object.values(groupedContacts);
                    setContacts(uniqueContacts);
    
                    // Controllo se esiste lastChatId nel sessionStorage
                    const lastChatId = sessionStorage.getItem("lastChatId");
                    const lastChat = lastChatId 
                        ? uniqueContacts.find(contact => contact.idReso === parseInt(lastChatId)) 
                        : uniqueContacts[0];
    
                    // Imposto la chat attiva e la cronologia in base a lastChatId
                    if (lastChat) {
                        setActiveChat(lastChat);
                        setChatHistory(lastChat.messaggi);
                        setLastReceivedMessageId(lastChat.messaggi[lastChat.messaggi.length - 1]?.id);
                    } else if (uniqueContacts.length > 0) {
                        setActiveChat(uniqueContacts[0]);
                        setChatHistory(uniqueContacts[0].messaggi);
                        setLastReceivedMessageId(uniqueContacts[0].messaggi[uniqueContacts[0].messaggi.length - 1]?.id);
                    }
                }
            } catch (error) {
                console.error("Errore nel recupero dei contatti:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchContacts();
    }, []);
    
    

    useEffect(() => {
        if (activeChat) {
            sessionStorage.setItem("activeChat", JSON.stringify(activeChat));
        }
    }, [activeChat]);


   // Fetch della cronologia dei messaggi quando si seleziona una chat
const fetchChatHistory = async (chatId, idReso) => {
    try {
        // const response = await axios.get(`http://localhost:8080/messaggio/${chatId}`, { headers });
        const response = await ApiService.request("cronologiaChat", { chatId: chatId});
        if (response.data && response.data.idReso === idReso) {
            const history = response.data.testi.map((msg) => ({
                from:   msg.idMittente,
                text:   msg.descrizione,
                date:   msg.data,
                id:     msg.id,
            }));
            setChatHistory(history);
             // Aggiorno solo se ricevo un nuovo messaggio dal SAT
            const lastMessage = history[history.length - 1];
            if (lastMessage.from !== idCliente && lastMessage.id !== lastReceivedMessageId) {
                setMessageCount(0); 
                setLastReceivedMessageId(lastMessage.id);
            }
        }
    } catch (error) {
        console.error("Errore nel caricamento della cronologia chat:", error);
    }
};


    // Gestione selezione chat
    const handleContactClick = (contact) => {
        setActiveChat(contact);
        setChatHistory(contact.messaggi);
        fetchChatHistory(contact?.id, contact?.idReso);
        sessionStorage.setItem("lastChatId", contact?.idReso);
    };

        // useEffect per Aggiungere il contatto inviato da TabellaDashboardSAT solo se non è già presente
        useEffect(() => {
            const newContact = location.state?.contact;
            if (newContact) {
                const contactExists = contacts.some(contact => contact.idReso === newContact.idReso);
                if (!contactExists) {
                    const updatedContacts = [...contacts, newContact];
                    setContacts(updatedContacts);
                    sessionStorage.setItem("contacts", JSON.stringify(updatedContacts)); 
                }
                setActiveChat(newContact); 
            }
        }, [location.state, contacts]);


        // Aggiorna lo stato `messageCount` con il valore salvato o 0 se non esiste
        useEffect(() => {
            const savedMessageCount = sessionStorage.getItem(`messageCount_${activeChat?.idReso}`);
            if (savedMessageCount) {
                setMessageCount(parseInt(savedMessageCount, 10));
            }
        }, [activeChat]);

        // Aggiorna il valore del `sessionStorage` quando `messageCount` cambia
        useEffect(() => {
            if (activeChat?.idReso) {
                sessionStorage.setItem(`messageCount_${activeChat.idReso}`, messageCount);
            }
        }, [messageCount, activeChat]);



        const handleSend = async () => {

            if (messageCount >= 3) {
                setSnackbarOpen(true); 
                return;
            }

            const now     = new Date();
            const day     = String(now.getDate()).padStart(2, '0');
            const month   = String(now.getMonth() + 1).padStart(2, '0'); // Perché i mesi in JavaScript vanno da 0 a 11
            const year    = now.getFullYear();
            const hours   = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const id      = activeChat?.id || null;   


            const datiMessaggio = {
                tipo:           1, // 1 per la chat, 0 per gli avvisi
                idMittente:     idCliente,
                idDestinatario: 1,
                testo:          newMessage,
                idReso:         activeChat?.idReso,
                id:             id,
                data:           (`${day}/${month}/${year} ${hours}:${minutes}`).replace(/%2F/g, "/")
                };

        
            try {
                const urlMessaggio = "/messaggio/salva";

                
                const response = await axios.post(urlMessaggio, datiMessaggio, { headers: headers });                
                if (response.data !== "ERRORE") {
                    setChatHistory((prevHistory) => [
                        ...prevHistory,
                        {
                            from: datiMessaggio.idMittente,
                            text: newMessage,
                            date: datiMessaggio.data,
                            id:   datiMessaggio.id,
                        }
                    ]);
                    setNewMessage('');
                    setMessageCount((prevCount) => {
                        const newCount = prevCount + 1;
                        sessionStorage.setItem(`messageCount_${activeChat.idReso}`, newCount);
                        return newCount;
                    });
                    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
                }
            } catch (error) {
                console.error("Errore durante l'invio del messaggio:", error);
            }
        };


        const handleSnackbarClose = () => {
            setSnackbarOpen(false);
        };
    

    return (
        <Container maxWidth="false" sx={{ display: 'flex', height: 'calc(100vh - 110px)'}}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    borderRadius: '20px',
                    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                }}
            >
            <Box 
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderRight: '1px solid #e0e0e0',
                    bgcolor: '#f5f5f5',
                    borderRadius: '20px 0px 0px 20px',
                    height: '100%'
                }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: '2em', m: 2, color: '#FDA03D'}}>Chat</Typography>
            <Divider sx={{ width: '100%', border: 'solid 0.5px #E0E0E0' }} />
            <ContactsList 
                contacts={contacts} 
                onContactClick={handleContactClick} 
            />
            </Box>
            {activeChat && (
                    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Box sx={{ flex: 1, overflowY: 'auto' }}>
                        <MessagesList 
                        messages={chatHistory} 
                        activeChat={activeChat}
                        loading={loading}
                        idSAT={idCliente}
                        />
                        <Box ref={chatEndRef} />
                    </Box>
                    <MessageInput
                        value={newMessage}
                        onChange={(e) => setNewMessage(e.target.value)}
                        onSend={handleSend}
                    />
                </Box>
            )}
            </Box>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity="warning" sx={{ width: '100%' }}>
                    In attesa di risposta dall'operatore
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default ChatPageCliente;
